module.exports = __webpack_public_path__ + "assets/caaf4f8fb4f139e66123a2888fb03028.mp3";